import React from 'react'

export default function Nosotros() {
  return (
    <div className='fondito2'>
    <div
className="hero min-h-screen background-2 ">
<div className="hero fondito min-h-screen">
<div className="hero-content beneficios">
  <div className="">
     <h1  className="text-5xl font-bold h1-bottom">Impacto Positivo en la Infraestructura del Transporte</h1>

     
    <div className='icon-text'> 
      <div className='fondo-icon'>
      <img className='iconos' src="img/bridge.png" alt="Descripción de la imagen"/>
      </div>
      <div>
      <h2 className="text-2xl font-bold">Reducción de Congestiones</h2>
      <p className='p-1-5'>Optimización del flujo de tráfico en las ciudades, lo que reduce la congestión y el tiempo de viaje.</p>
      <hr class="solid"></hr>
      </div>
      </div>
      
      
      <div className='icon-text'> 
      <div className='fondo-icon'>
      <img  className='iconos' src="img/leaves.png" alt="Descripción de la imagen"/>
      </div>
      <div>
      <h2 className="text-2xl font-bold">Menos Emisiones</h2>
      <p className='p-1-5'>Utilización de nuevas tecnologías con menor impacto ambiental.</p>
      <hr class="solid"></hr>
      </div>
      </div>

      <div className='icon-text'> 
      <div className='fondo-icon'>
      <img className='iconos' src="img/school-bus.png" alt="Descripción de la imagen"/>
      </div>
      <div>
      <h2 className="text-2xl font-bold">Mejor Acceso</h2>
      <p className='p-1-5'>Acceso a servicios de transporte asequibles y convenientes para todos los ciudadanos, sin importar de su ubicación.</p>
      <hr class="solid"></hr>
      </div>
      </div>

      <div className='icon-text'> 
      <div className='fondo-icon'>
      <img className='iconos' src="img/shield.png" alt="Descripción de la imagen"/>
      </div>
      <div>
      <h2 className="text-2xl font-bold">Mayor Seguridad en el Transporte</h2>
      <p className='p-1-5'>Optimización del flujo de tráfico en las ciudades, lo que reduce la congestión y el tiempo de viaje.</p>
      <hr class="solid"></hr>
      </div>
      </div>
      
    
    
  </div>
</div>
</div>
</div>
  </div>
  )
}
